import type { IUserMilestone } from '../../IUserMilestone';

/**
 * Retailer has opted out of the POS marketing banners
 */
export const POS_MARKETING_BANNERS_DISMISSED =
  'POS_MARKETING_BANNERS_DISMISSED' as IUserMilestone.RetailerMilestone;
